module.exports = __webpack_public_path__ + "static/media/india-flag.0f9ac1ba.png";